import * as Actions from '../../actions/listing/type';

const initialState = {
  createCannedLoading: false,
  updateCannedLoading: false,
  deleteCannedLoading: false,

  createdCannedJob: {},
  updatedCannedJob: {},
  deletedCannedJob: {},
};

const cannedReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create pricing matrix
    case Actions.CREATE_CANNED_JOBS_REQUEST:
      return {
        ...state,
        createCannedLoading: true,
      };
    case Actions.CREATE_CANNED_JOBS_SUCCESS:
      return {
        ...state,
        createCannedLoading: false,
        createdCannedJob: action?.payload?.data || {},
      };
    case Actions.CREATE_CANNED_JOBS_FAIL:
      return {
        ...state,
        createCannedLoading: false,
        error: action.payload,
      };

    // update pricing matrix
    case Actions.UPDATE_CANNED_JOBS_REQUEST:
      return {
        ...state,
        updateCannedLoading: true,
      };
    case Actions.UPDATE_CANNED_JOBS_SUCCESS:
      return {
        ...state,
        updateCannedLoading: false,
        updatedCannedJob: action?.payload?.data || '',
      };
    case Actions.UPDATE_CANNED_JOBS_FAIL:
      return {
        ...state,
        updateCannedLoading: false,
        error: action.payload,
      };

    // delete pricing matrix
    case Actions.DELETE_CANNED_JOBS_REQUEST:
      return {
        ...state,
        deleteCannedLoading: true,
      };
    case Actions.DELETE_CANNED_JOBS_SUCCESS:
      return {
        ...state,
        deleteCannedLoading: false,
        deletedCannedJob: action?.payload?.data || '',
      };
    case Actions.DELETE_CANNED_JOBS_FAIL:
      return {
        ...state,
        deleteCannedLoading: false,
        error: action.payload,
      };
    case Actions.CLEAR_CANNED_JOB_STATE:
      return {
        ...state,
        createCannedLoading: false,
        updateCannedLoading: false,
        deleteCannedLoading: false,

        createdCannedJob: {},
        updatedCannedJob: {},
        deletedCannedJob: {},
      };
    default:
      return state;
  }
};

export default cannedReducer;
